import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Grid,
  MenuItem,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import { getAllZoneSummary } from '../service/zoneService';
import { saveShipperInfo, getvehicleType, fetchShipperInfo } from '../service/shipperService'; // Service to call backend
import { useAuth } from '../context/AuthContext';
import FormInstructionBox from '../components/FormInstructionBox';

const countries = ["India"];
const states = ["Tamil Nadu"];
//const zones = ["North", "South", "East", "West", "Central"];
//const vehicleTypes = ["Truck", "Van", "Bike", "Car"];


const ShipperForm = ({ initialData }) => {
     const { user } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    licenseNumber: "",
    adhar: "",
    panNumber: "",
    email: "",
    contactNumber: "",
    additionalContact: "",
    emergencyContact: "",
    homeAddress: {
    street1: '',
      street2: '',
    city: '',
    postalCode: '',
      country: '',
    state: '',
      phone: '',
      email: '',
      addressType: 'SHIPPING'
  },
    city: "",
    state: "",
    country: "",
    homeZones: [],
    vehicleTypeId: "",
    userId: user.userId,
    ...initialData, // preload data if editing
  });
    const [zones, setZones] = useState([]);
   const [vehicleTypes, setVehicleTypes] = useState([]);
  const isApproved = initialData && initialData.isApproved;
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', msg: '' }); // Tracks 'success' or 'error'
  
    const shipformInstructions = [
        "Fill in the correct information, the Foodsakz team will review and approve or reject.",
        "The informatiom are used to find the shipper in the foodsakz system. we dont share the information.",
        "After approved, you are not able to change or update the fields.",
        "Fill in all the required fields and then click on Save or Update.",
        "If you have any Questions or need more help. Please contact the System Administrator.WhatsApp or Phone: +91 999 464 1128"
    ];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', msg: '' }); // Reset message on new attempt

    try {
      // Assuming onSubmit is an axios call: e.g., axios.post(...)
      await  saveShipperInfo(formData);
      
      setStatus({ 
        type: 'success', 
        msg: 'Thank you. Your Information is Successfully saved!' 
      });
    } catch (error) {
      setStatus({ 
        type: 'error', 
        msg: error.response?.data?.message || 'Failed to save. Please try again or contact administrator.' 
      });
    }

      
  
  };
  
   useEffect(() => {
  //   fetchShipper();
    fetchZones(); 
     fetchVehicleTypes();
  }, []);
  


  const fetchZones = async () => {
    setLoading(true);
    try {
      const res = await getAllZoneSummary(); //axiosInstance.get("/api/zones");
      setZones(res.data);
    } catch (err) {
      console.error("Error fetching zones:", err);
    }
    setLoading(false);
  };
  
    const fetchVehicleTypes = async () => {
    setLoading(true);
    try {
      const res = await getvehicleType(); //axiosInstance.get("/api/zones");
      setVehicleTypes(res.data);
    } catch (err) {
      console.error("Error fetching zones:", err);
    }
    setLoading(false);
  };
  
  const handleAddressChange = (e) => {
  const { name, value } = e.target;
  
  // Update the nested address object
  setFormData(prevFormData => ({
    ...prevFormData, // 1. Copy all top-level fields (like otherField1)
    homeAddress: {
      ...prevFormData.homeAddress, // 2. Copy all existing address fields (like city, pincode)
      [name]: value // 3. Overwrite the specific field that changed (e.g., street)
    }
  }));
};


  return (
    <>
 
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        p: 3,
        bgcolor: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      <Paper
        elevation={4}
        sx={{
          maxWidth: 900,
          width: "100%",
          p: 4,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          sx={{ fontWeight: "bold", textAlign: "center", mb: 3 }}
        >
          {initialData ? "Edit Shipper Information" : "Add Shipper Information"}
        </Typography>
    <FormInstructionBox 
                instructions={shipformInstructions} 
                title="Shipper Details Guidelines" 
            />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Basic Info */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Full Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="date"
                label="Date of Birth"
                name="dob"
                InputLabelProps={{ shrink: true }}
                value={formData.dob}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>

            {/* License & Contact */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="License Number"
                name="licenseNumber"
                value={formData.licenseNumber}
                onChange={handleChange}
                required
                                InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            {/* License & Contact */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="PAN Number"
                name="panNumber"
                value={formData.panNumber}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            {/* License & Contact */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Adhar Number"
                name="adhar"
                value={formData.adhar}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="email"
                label="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>

            {/* Phone Numbers */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Primary Contact"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Additional Contact"
                name="additionalContact"
                value={formData.additionalContact}
                onChange={handleChange}
                InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Emergency Contact"
                name="emergencyContact"
                value={formData.emergencyContact}
                onChange={handleChange}
 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>

            {/* Address */}

                  
                           <Grid item xs={12}> 
                <Typography variant="h6">Permanant Address</Typography>
                <TextField
                  label="Street Line 1"
                  name="street1"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.street1}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="Street Line 2"
                  name="street2"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.street2}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="City"
                  name="city"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.city}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="State"
                  name="state"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.state}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="Country"
                  name="country"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.country}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="Postal Code"
                  name="postalCode"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.postalCode}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="Phone"
                  name="phone"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.phone}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
                <TextField
                  label="Email"
                  name="email"
                  fullWidth
                  variant="outlined"
                  value={formData.homeAddress.email}
                  onChange={handleAddressChange}
                  style={{ margin: '10px 0' }}
                   InputProps={{
                readOnly: isApproved
                }}
                />
     
              </Grid>
                      
        

    <Grid item xs={12}> 
 <Typography variant="h6">Shipping Support Location</Typography>

            <Grid item xs={12} >
              <TextField
                fullWidth
                label="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                label="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              >
                {states.map((s) => (
                  <MenuItem key={s} value={s}>
                    {s}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} >
              <TextField
                select
                fullWidth
                label="Country"
                name="country"
                value={formData.country}
                onChange={handleChange}
                required
                 InputProps={{
                readOnly: isApproved
                }}
              >
                {countries.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
<Grid item xs={12} >
  <TextField
    select
    fullWidth
    label="Home Zones"
    name="homeZones"
    // 1. FIX: Convert the state [{id: 1}, {id: 2}] back to an array of IDs [1, 2]
    // The Select component's value MUST match the MenuItem values (which are IDs)
    value={formData.homeZones.map(zoneObj => zoneObj.id) || []}
    
    onChange={(e) => {
      // e.target.value is now an array of selected primitive IDs (e.g., [1, 2])
      const selectedIds = e.target.value; 
      
      setFormData({
        ...formData,
        // 2. Keep your backend format: Convert the IDs back to [{id: 1}, {id: 2}]
        homeZones: selectedIds.map((id) => ({ id })), 
      });
    }}
    SelectProps={{
      multiple: true,
      // 3. RENDER FIX: 'selected' here is the array of IDs [1, 2], NOT objects
      renderValue: (selectedIds) => 
        selectedIds.map((id) => {
          // Find the full zone object using the ID
          const zone = zones.find((zone) => zone.id === id);
          return zone ? zone.name : id;
        }).join(", "),
    }}
     InputProps={{
                readOnly: isApproved
                }}
  >
    {/* 4. MenuItems must pass the ID as the value */}
    {zones.map((z) => (
      <MenuItem key={z.id} value={z.id}>
        {z.name}
      </MenuItem>
    ))}
  </TextField>
</Grid>
            <Grid item xs={12} >
              <TextField
                select
                fullWidth
                label="Vehicle Type"
                name="vehicleTypeId"
                value={formData.vehicleTypeId}
                onChange={handleChange}
 InputProps={{
                readOnly: isApproved
                }}
              >
                {vehicleTypes.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.code}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
 </Grid>
            {/* Submit */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2, py: 1.5, fontSize: "16px" }}
                disabled={isApproved} 
              >
                {initialData ? "Update Shipper" : "Save Shipper"}
              </Button>
            </Grid>
{status.msg && (
        <Typography 
          sx={{ mt: 2 }} 
          color={status.type === 'success' ? 'success.main' : 'error.main'}
        >
          {status.msg}
        </Typography>
      )}
          </Grid>
        </form>
      </Paper>
    </Box>
</>
  );
};

export default ShipperForm;